const routes = [
  {
    name: "softphoneWidget",
    path: "/softphone-widget",
    components: {appView: () => import("@/views/softphone-widget/TheSoftphoneWidget.vue")},
    meta: {
      access_control: ["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_AGENT", "ROLE_USER"],
      requiresAuth: true,
    }
  }
]

export default routes;